import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../atom/Dropdown/Dropdown";
import clsx from "clsx";
import { useState } from "react";
import MoreIcon from "../../../atom/icons/MoreIcon";
import Tooltip from "../../../atom/Tooltip";

const MoreDropdown = ({
  moreDropdownRef,
  onDataDuplicate,
  onTaskDelete,
}: {
  moreDropdownRef: React.RefObject<HTMLDivElement>;
  onDataDuplicate: (e: Event) => void;
  onTaskDelete: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const DropdownMenuList = [
    {
      label: "Duplicate",
      onSelect: (e: Event) => {
        onDataDuplicate(e);
      },
    },
    {
      label: "Delete",
      onSelect: (e: Event) => {
        onTaskDelete();
      },
    },
  ];

  const handleEscapeKeyDown = (e: KeyboardEvent) => {
    // esc 눌렀을 때 전파 막기(해당 dropdown만 닫히도록)
    e.stopPropagation();
  };

  const handleDropdownItemKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      // enter 눌렀을 때 상위 모달 닫히지 않도록 막기
      e.stopPropagation();
    }
  };

  return (
    <DropdownMenu
      modal={false}
      open={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
    >
      <Tooltip
        content="More"
        isShow={isOpen ? false : undefined}
      >
        <DropdownMenuTrigger asChild>
          <button
            className={clsx(
              "flex cursor-pointer select-none items-center justify-center rounded-[5px] bg-transparent p-[4px] text-80",
              "hover:bg-w-8-hover hover:text-white",
              { "bg-w-8-hover": isOpen }
            )}
          >
            <MoreIcon
              color={isOpen ? "#fff" : ""}
              className={"fill-80"}
            />
          </button>
        </DropdownMenuTrigger>
      </Tooltip>

      <DropdownMenuContent
        ref={moreDropdownRef}
        width="90px"
        sideOffset={5}
        align="end"
        className="w-[170px] text-white"
        onCloseAutoFocus={(e) => {
          e.preventDefault();
        }}
        onEscapeKeyDown={handleEscapeKeyDown}
      >
        <DropdownMenuGroup>
          {DropdownMenuList.map((item) => (
            <DropdownMenuItem
              key={item.label}
              onKeyDown={handleDropdownItemKeyDown}
              className="box-border flex h-8 w-full cursor-pointer items-center justify-between gap-[6px] px-2 text-[12px] text-80 data-[highlighted]:bg-w-8-hover data-[highlighted]:text-white data-[highlighted]:outline-none"
              onSelect={item.onSelect}
            >
              {item.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MoreDropdown;
